import React, { useEffect, useState } from 'react'

export default function EventDetails(props) {
    const [agenda, setAgenda] = useState("");
    const [showAgenda, setShowAgenda] = useState(false)
    const [meetingMaterials, setMeetingMaterials] = useState("");
    const [showMeetingMaterials, setShowMeetingMaterials] = useState(false);
    const [onePagers, setOnePagers] = useState("");
    const [showOnePagers, setShowOnePagers] = useState(false);
    const [image, setImage] = useState("")
    const [showImage, setShowImage] = useState(false);

    var data = props.Data;
    var title = data.title;
    var location = data.location;
    var locationLink = data.locationLink;
    var body = data.body;
    var start = data.start;
    var end = data.end;

    const formatDate = function (d) {
        var date = new Date(d);
        var res = '';
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1);
        var yyyy = date.getFullYear();
        var HH = date.getHours();
        var MM = String(date.getMinutes());
        var AMPM = HH >= 12 ? 'pm' : 'am';
        HH = HH % 12;
        HH = HH ? HH : 12;
        MM = MM < 10 ? '0' + MM : MM;
        res = mm + '/' + dd + '/' + yyyy + ' ' + HH + ":" + MM + AMPM;
        return res
    }

    useEffect(() => {
        console.log(data.onePagers)
        if (data.agenda.length > 0) {
            setShowAgenda(true)
        }
        setAgenda(data.agenda)

        if (data.meetingMaterials.length > 0) {
            setShowMeetingMaterials(true)
        }
        setMeetingMaterials(data.meetingMaterials)

        if (data.onePagers.length > 0) {
            setShowOnePagers(true)
        }
        setOnePagers(data.onePagers)

        if (data.image != undefined && data.image.length > 0) {
            setShowImage(true)
        }
        setImage(data.image)
    }, [props])

    return (
        <div>
            <div className='row px-3 py-3'>
                <div className='col-9'>
                    <h5 className='fw-bold'>{title}</h5>
                    <p><a href={locationLink} target="_blank">{location}</a></p>
                    {start == 'TBD' ? <p>Date and time are to be determined.</p> : <p>({formatDate(start)} - {formatDate(end)})</p>}
                    <p>{body}</p>
                </div>
                <div className='col-3'>
                    {showAgenda || showMeetingMaterials || showOnePagers ?
                        <h5 className='fw-bold text-center'>Document(s)</h5>
                        : <></>
                    }

                    {showAgenda ?
                        <div className='m-2 btn d-block docBtn' style={{ backgroundColor: '#FAAB53' }}>
                            <a href={agenda} target='_blank' className='text-light' style={{ textDecoration: 'none' }}>View Agenda</a>
                        </div>
                        : <></>
                    }

                    {showMeetingMaterials ?
                        <div className='m-2 btn d-block docBtn' style={{ backgroundColor: '#FAAB53' }}>
                            <a href={meetingMaterials} target='_blank' className='text-light' style={{ textDecoration: 'none' }}>View Meeting Materials</a>
                        </div>
                        : <></>
                    }

                    {showOnePagers ?
                        <div className='m-2 btn d-block docBtn' style={{ backgroundColor: '#FAAB53' }}>
                            <a href={onePagers} target='_blank' className='text-light' style={{ textDecoration: 'none' }}>View One-Pager</a>
                        </div>
                        : <></>
                    }

                </div>
            </div>
            <div className='row px-3 py-1 mb-3'>
                {showImage ? image.map((i)=><div style={{width:'50%'}} key={i}><img src={i} objectfit="cover" width="100%"/></div>) : <></>}
            </div>
            <div className='card-footer d-none'>
                <div className='d-flex flex-row justify-content-center' style={{ textAlign: 'center' }}>

                    {showAgenda ?
                        <div className='mx-4 btn' style={{ backgroundColor: '#FAAB53' }}>
                            <a href={agenda} target='_blank' className='text-light' style={{ textDecoration: 'none' }}>Agenda</a>
                        </div>
                        : <></>
                    }

                    {showMeetingMaterials ?
                        <div className='mx-4 btn' style={{ backgroundColor: '#FAAB53' }}>
                            <a href={meetingMaterials} target='_blank' className='text-light' style={{ textDecoration: 'none' }}>Meeting Materials</a>
                        </div>
                        : <></>
                    }

                    {showOnePagers ?
                        <div className='mx-4 btn' style={{ backgroundColor: '#FAAB53' }}>
                            <a href={onePagers} target='_blank' className='text-light' style={{ textDecoration: 'none' }}>One-Pagers</a>
                        </div>
                        : <></>
                    }
                </div>
            </div>
        </div>
    )
}
